<template>
    <div>
        <PaymentIframe v-model="iframePayment" :clientId="clientId"></PaymentIframe>

        <CustomDialog
            v-model="visible"
            :defaultTitle="$t('checkout.payment.collect')"
            :isInPopup="false"
            width="90%"
            height="85vh"
            @cancel="close"
            @confirm="submit"
        >
            <template #content>
                <form :action="action" method="POST" ref="form">
                    <OverlayBody>
                        <template #overlay-header>
                            <OverlayHeader
                                :routeCustomerFile="routeCustomerFile"
                                :currentCustomer="currentCustomer"
                                v-on:show-iframe="(userId) => redirect_userPayment(userId)"
                            ></OverlayHeader>
                        </template>

                        <template #card-component>
                            <cart-component
                                :accompte="accompte"
                                :rest="rest"
                                :totalAccompte="totalAccompte"
                                :totalWithDiscount="totalWithDiscount"
                                :cartTotal="cartTotal"
                                :promoCode="promoCode"
                                :saveBasketRoute="saveBasketRoute"
                                @submit-form="submit"
                                @used-fidelity-points="updateFidelityPoints"
                                @delete-code="deleteCode"
                                :orderId="orderId"
                                :walletTransaction="walletTransaction"
                                :isClotured="isClotured"
                                :orderObj="orderObj"
                                :canCreateOrder="canCreateOrder"
                                :canModifyOrder="canModifyOrder"
                                :canDeleteOrder="canDeleteOrder"
                            ></cart-component>
                        </template>

                        <template #payment-component>
                            <payment-component
                                ref="payment"
                                :customer="customer"
                                :promoCodes="promoCodes"
                                :promoCode="promoCode"
                                :paymentMethods="paymentMethods"
                                :usedFidelityPoints="usedFidelityPoints"
                                :cartTotal="cartTotal"
                                :rest="rest"
                                :accompte="accompte"
                                :currentOrder="c_order"
                                :promotions="promotions"
                                :userId="userId"
                                :orderId="orderId"
                                :walletTransaction="walletTransaction"
                                :customerWalletBalance="customerWalletBalance"
                                :stripeKey="stripeKey"
                                :canCreateOrder="canCreateOrder"
                                :canModifyOrder="canModifyOrder"
                            ></payment-component>
                        </template>

                        <template #voucher-tab>
                            <voucher-tab @vouchers-update="updateVoucherAmount"></voucher-tab>
                        </template>

                        <template #serie-treatment-tab>
                            <serie-treatment-tab></serie-treatment-tab>
                        </template>
                        <template #serie-tab>
                            <serie-tab></serie-tab>
                        </template>

                        <template #contributor-tab>
                            <contributor-tab
                                :contributors="c_order ? c_order.contributors : []"
                                :currentTotal="c_order ? c_order.total_price : 0"
                                :isUpdate="false"
                            ></contributor-tab>
                        </template>

                        <template #waiting-sales-tab>
                            <waiting-sales-tab :incompleted-orders="incompletedOrders"></waiting-sales-tab>
                        </template>
                        <template #actions-buttons>
                            <ActionsButtons
                                :promoCode="promoCode"
                                :orderId="orderId"
                                :walletTransaction="walletTransaction"
                                :orderObj="orderObj"
                                :isCartItemsLoaded="isCartItemsLoaded"
                                :canCreateOrder="canCreateOrder"
                                :canModifyOrder="canModifyOrder"
                                @submit-form="submit"
                            ></ActionsButtons>
                        </template>
                        <template #deposits>
                            <Deposits></Deposits>
                        </template>
                        <template #security>
                            <Security></Security>
                        </template>
                    </OverlayBody>
                </form>
            </template>
            <!-- Hide default actions since we have custom buttons inside -->
            <template #actions>
                <span></span>
            </template>
        </CustomDialog>
    </div>
</template>

<script>
import PaymentIframe from '../../Calendar/Iframe/PaymentIframe'
import { sync, get } from 'vuex-pathify'
import InitManager from './_core/InitManager'
import ApiManager from './_core/ApiManager'
import OverlayHeader from './OverlayHeader.vue'
import OverlayBody from './OverlayBody.vue'
import CloseSaleModal from './CloseSaleModal.vue'
import axios from 'axios'
import ActionsButtons from './ActionsButtons.vue'
import Deposits from './Deposits.vue'
import Security from './Security.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'

export default {
    components: { PaymentIframe, OverlayHeader, OverlayBody, CloseSaleModal, ActionsButtons, Deposits, Security, CustomDialog },
    props: [
        'currentCustomer', // (type USER)
        'routeCustomerFile', // (Url profil client)

        'cartTotal', // Backet amount (computed by back)
        'paymentMethods', // List of payment methods (establishment)
        'promoCodes', // List of promoCode (establishment)

        'action', // (URL post formulaire)
        'rest', // (Already paid)
        'accompte', // accompte

        'cartItems', // (Basket list)
        'incompletedOrders', // (Basket sauvergarder client)
        'establishment', // (Etablissement)

        'saveBasketRoute', // (URL de sauvegarde de panier)

        'orderId', // Order Id
        'walletTransaction', // walletTransaction Uuid
        'customerWalletBalance', // customer wallet balance
        'promotions',
        'userId',
        'isClotured',
        'orderObj',
        'canCreateOrder',
        'canModifyOrder',
        'canDeleteOrder',
    ],
    data: () => ({
        visible: false,
        clientId: null,
        iframePayment: false,

        payments: [],

        totalPaid: 0,
        order: null,
        selectedPaymentMethods: [],

        // promo code
        selectCode: [],
        promoCode: null,
        promoCodeApplied: false,
        wrongPromoCode: null,

        totalWithDiscount: 0,
        clientId: null,
        totalDiscount: 0,

        // voucher
        voucherAmount: 0,
        customer: null,

        totalAccompte: 0.0,
        totalWRest: 0.0,

        //fidelity points
        usedFidelityPoints: 0,

        //treatments and series
        treatmentIndex: null,
        serieIndex: null,
        prepaidPrestations: [],

        //close sale
        closeSaleModal: false,

        // Stripe key
        stripeKey: null,
    }),
    async created() {
        this.c_overlay = InitManager.createInitialCheckoutOverlayState()
        this.c_customer = this.currentCustomer
        this.paymentMethods.forEach((e) => {
            // if (!e.name.includes('Abonnement') && !e.name.includes('Cure') && !e.name.includes('cadeau')) {
            this.c_payments.push({ name: e.name, value: 0, color: e.color, display_name: e.display_name })
            //}
        })
        // this.c_payments.push({ name: 'Remise personnalisée', value: 0, isRemisePersonalisee: true })
        this.c_establishment = this.establishment
        if (this.cartItems) {
            const cards = { ...this.cartItems }
            for (const key in cards) {
                cards[key].code = null // observable
            }
            this.c_cartItems = cards

            // Parallelize fetching seller and advised info
            const userIdsToFetch = []
            for (const key of Object.keys(this.cartItems)) {
                if (this.cartItems[key].options.seller_id) userIdsToFetch.push(this.cartItems[key].options.seller_id)
                if (this.cartItems[key].options.advised_id) userIdsToFetch.push(this.cartItems[key].options.advised_id)
            }

            if (userIdsToFetch.length > 0) {
                axios
                    .post('/back-office/user/get/user/by/array', { users: [...new Set(userIdsToFetch)] })
                    .then((res) => {
                        const usersMap = {}
                        res.data.forEach((user) => {
                            usersMap[user.id] = {
                                id: user.id,
                                email: user.email,
                                first_name: user.first_name,
                                last_name: user.last_name,
                            }
                        })

                        const updatedCartItems = { ...this.c_cartItems }
                        for (const key of Object.keys(updatedCartItems)) {
                            const sellerId = updatedCartItems[key].options.seller_id
                            const advisedId = updatedCartItems[key].options.advised_id
                            if (sellerId && usersMap[sellerId]) updatedCartItems[key].seller = usersMap[sellerId]
                            if (advisedId && usersMap[advisedId]) updatedCartItems[key].advised = usersMap[advisedId]
                        }
                        this.c_cartItems = updatedCartItems
                    })
                    .catch((err) => {
                        console.error('Error fetching users for cart items:', err)
                    })
            }

            if (
                this.c_cartItems[Object.keys(this.c_cartItems)[0]] &&
                this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.order_id
            ) {
                await this.getOrder(this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.order_id)
            } else if (
                this.c_cartItems[Object.keys(this.c_cartItems)[0]] &&
                this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.booking_id
            ) {
                await this.getOrderByBookingId(this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.booking_id)
            }
        }
        // Load Promo Codes of booking
        if (this.c_order) {
            axios
                .get(`/back-office/promotion/get/code/orderid/${this.c_order.id}`)
                .then((res) => (this.c_tmpPromoCodes = res.data))
        }
    },
    async mounted() {
        window.addEventListener('open-checkout-overlay', () => {
            this.visible = true
        })

        // Check URL params for overlay
        const params = new URLSearchParams(window.location.search)
        if (params.get('overlay') === 'true') {
            this.visible = true
        }

        this.totalWithDiscount = this.cartTotal
        this.cartRest = this.cartTotal
        this.totalWRest =
            this.cartTotal -
            this.rest -
            this.payments.reduce((previous, current) => parseFloat(previous, 10) + parseFloat(current || 0, 10), 0)
        this.checkPromoBefore()
        this.treatmentIndex = this.paymentMethods.findIndex((el) => el.name.includes('Cure'))
        this.serieIndex = this.paymentMethods.findIndex((el) => el.name.includes('Abonnement'))
        if (document.getElementById('customerSelect')) {
            window.customer = document.getElementById('customerSelect').value
            this.customer = window.customer
        }

        // Fetch Stripe publishable key
        try {
            const response = await axios.get('/api/v1/payment/stripe-publishable-key')
            this.stripeKey = response.data.key
        } catch (error) {
            this.$toast.error(error.message)
        }
    },
    methods: {
        close() {
            this.visible = false
        },
        updateVoucherAmount(vouchersUsed) {
            if (vouchersUsed?.length == 0) {
                this.voucherAmount = 0
            } else {
                this.voucherAmount = vouchersUsed.reduce((prev, cur) => prev + cur, 0)
            }
        },

        updateFidelityPoints(fidelityPoints) {
            this.usedFidelityPoints = fidelityPoints
        },

        showAlertPrepaid(prepaidPrestations) {
            this.c_prepaidPrestations = [...prepaidPrestations]
        },

        unshowAlertPrepaid(prepaidPrestations) {
            this.c_prepaidPrestations = [...prepaidPrestations]
        },

        submit() {
            this.$refs.form.submit()
        },

        redirect_userPayment(id) {
            this.iframePayment = true
            this.clientId = id
        },

        checkPromoBefore() {
            if (this.promoOrder) {
                this.promoOrder.forEach((element) => {
                    this.promoCode = element.code
                    this.promoCodeEntered = element.code
                    this.checkPromoCode()
                })
            }
        },

        decrementRest(event) {
            const price = event.target.value

            this.cartRest = this.cartRest - price
            if (this.cartRest > 0) {
            }
        },

        // Set total price with voucher amount
        setTotalPrice(index, method) {
            if (this.remainPrice > 0) {
                if (method.includes('cadeau')) {
                    if (this.voucherApplied) {
                        if (this.voucherTotal >= this.remainPrice) {
                            this.payments[index] = this.remainPrice
                        } else {
                            this.payments[index] = this.voucherTotal
                        }
                    }
                } else {
                    this.payments[index] = this.remainPrice
                }
                const tmp = this.payments
                this.payments = []
                this.payments = tmp
            }
        },

        addDiscountOnItem(rowId, price) {
            axios
                .post(`/back-office/caisse/${rowId}/addDiscount`, {
                    price: price,
                })
                .then((res) => {
                    //
                })
        },
        addDiscountOnBasket(rowId, price) {
            axios
                .post(`/back-office/caisse/addDiscountBasket`, {
                    price: price,
                })
                .then((res) => {
                    //
                })
        },
        getTotalWithDiscount() {
            var response = 0
            axios.get(`/back-office/caisse/getTotalWithDiscount`).then((res) => {
                response = res.data
            })
            return response
        },
        getTotalWithoutDiscount() {
            axios.get(`/back-office/caisse/getTotalWithoutDiscount`).then((res) => {
                response = res.data
            })
            return response
        },
        _computeAmountCodePromo(amount, currentCode) {
            let res = 0

            if (currentCode.discount_type == 'fixed') {
                let totalPrice = Object.values(this.c_cartItems)
                    .filter((x) => x.code != undefined && x.code != null)
                    .reduce(function (res, item) {
                        return res + item._oldPrice * item.qty
                    }, 0)

                let rate = Math.min(currentCode.discount_amount / totalPrice, 1)
                res = amount * rate
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },
        async getOrder(id) {
            return axios
                .get(`/back-office/get/order`, {
                    params: { id: id },
                })
                .then((res) => {
                    this.c_order = res.data
                })
        },
        async getOrderByBookingId(id) {
            return axios
                .get(`/back-office/get/booking/order`, {
                    params: { id: id },
                })
                .then((res) => {
                    this.c_order = res.data
                })
        },
        deleteCode(index) {
            this.$refs.payment.deleteCode(index)
        },
    },
    //TODO: FIX les codes promo quand on rajoute des produit aux panier avec une prestation avec un accompte
    computed: {
        c_overlay: sync('overlay'),
        ...sync('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_customer: 'customer',
            c_payments: 'payments',
            c_establishment: 'establishment',
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
            c_tmpPromoCodes: 'tmpPromoCodes',
            c_order: 'order',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
        }),
        ...get('overlay@data', {
            c_customDiscount: 'customDiscount',
            c_prepaidPrestations: 'prepaidPrestations',
        }),
        isCartItemsLoaded() {
            return this.c_cartItems && Object.keys(this.c_cartItems).length > 0
        },
        remainPrice() {
            let remainPlain = 0

            if (this.promoCodeApplied) {
                this.selectCode.push(this.promoCode)
                this.promoCodeApplied = false
            }

            let remain = 0.0
            let price = 0
            let price_product = 0
            this.totalAccompte = 0.0
            let price_product_base = 0

            // Abonnements et cures
            if (this.c_prepaidPrestations && this.c_payments) {
                // Reset les prépaiements déjà passés
                // if (this.c_payments.findIndex((p) => p.name == 'Abonnement') != -1) {
                //     this.c_payments.splice(
                //         this.c_payments.findIndex((p) => p.name == 'Abonnement'),
                //         1
                //     )
                // }
                // if (this.c_payments.findIndex((p) => p.name == 'Cure') != -1) {
                //     this.c_payments.splice(
                //         this.c_payments.findIndex((p) => p.name == 'Cure'),
                //         1
                //     )
                // }
                if (this.c_payments.findIndex((p) => p.name.toLowerCase() == 'abonnement') != -1)
                    this.c_payments.find((p) => p.name.toLowerCase() == 'abonnement').value = 0
                if (this.c_payments.findIndex((p) => p.name.toLowerCase() == 'cure') != -1)
                    this.c_payments.find((p) => p.name.toLowerCase() == 'cure').value = 0
                // Ajoute les prépaiements
                this.c_prepaidPrestations.forEach((item) => {
                    if (item.prepaid.type == 'serie') {
                        if (this.c_payments.findIndex((p) => p.name.toLowerCase() == 'abonnement') != -1)
                            this.c_payments.find((p) => p.name.toLowerCase() == 'abonnement').value +=
                                item.prestation.price / item.prestation.qty
                    } else if (item.prepaid.type == 'treatment') {
                        if (this.c_payments.findIndex((p) => p.name.toLowerCase() == 'cure') != -1)
                            this.c_payments.find((p) => p.name.toLowerCase() == 'cure').value +=
                                item.prestation.price / item.prestation.qty
                    }
                })
            }

            this.c_promoCodeNoCompleteUsed = []
            // Parcours des produits du panier
            for (const key in this.c_cartItems) {
                // [Codes Promo]
                this.c_cartItems[key].codePromo = []
                // if (this.c_cartItems[key].options.type === 'App\\Models\\Voucher\\Voucher') {
                //     let price = this.c_cartItems[key]._oldPrice

                //     if (this.c_promoCodes && this.c_cartItems[key]._oldPrice) {
                //         this.c_promoCodes
                //             .filter((x) => x.has_voucher || x.is_global)
                //             .forEach((code) => {
                //                 this.c_cartItems[key]._oldPrice = this.c_cartItems[key]._oldPrice
                //                 const computedPrice = this._computeAmountCodePromo(price, code)

                //                 const p = computedPrice > price ? price : computedPrice
                //                 const remiseP = !code.has_voucher && !code.is_global ? 0 : p
                //                 this.c_cartItems[key].codePromo.push({
                //                     itemKey: key,
                //                     code: code,
                //                     remise: remiseP,
                //                 })
                //                 price -= remiseP
                //             })
                //         this.c_cartItems[key].price = price < 0 ? 0.0 : price
                //     }
                // } else {
                if (this.c_cartItems[key].code && this.c_cartItems[key]._oldPrice) {
                    let price = this.c_cartItems[key]._oldPrice

                    this.c_cartItems[key].code
                        //  .filter((x) => !x.global || x.discount_type != 'fixed')
                        .filter((x) => true)
                        .forEach((code) => {
                            const computedPrice = this._computeAmountCodePromo(price, code)
                            const p = computedPrice > price ? price : computedPrice
                            this.c_cartItems[key].codePromo.push({ itemKey: key, code: code, remise: !code.enable ? 0 : p })
                            price -= !code.enable ? 0 : p
                        })
                    this.c_cartItems[key].price = price < 0 ? 0.0 : price
                }
                // }

                // [Codes Promo] "global fixed"

                // if (this.c_cartItems[key].code && this.c_cartItems[key]._oldPrice) {
                //     let price = this.c_cartItems[key].price

                //     this.c_cartItems[key].code
                //         .filter((x) => x.enable && x.global && x.discount_type == 'fixed')
                //         .forEach((code) => {
                //             const used = this.c_promoCodeNoCompleteUsed.reduce((prev, current) => {
                //                 if (current.codeId != code.id) return prev
                //                 return prev + current.used
                //             }, 0)

                //             const reduc = code.discount_amount - used
                //             let tmp = {
                //                 itemKey: key,
                //                 remain: reduc - price < 0 ? 0 : reduc - price,
                //                 amount: reduc,
                //                 codeId: code.id,
                //                 used: 0,
                //             }
                //             tmp.used = tmp.amount - tmp.remain
                //             this.c_cartItems[key].codePromo.push({ itemKey: key, code: code, remise: tmp.used })
                //             this.c_promoCodeNoCompleteUsed.push(tmp)
                //             price -= reduc
                //         })
                //     this.c_cartItems[key].price = price < 0 ? 0.0 : price
                // }

                price = 0
                price_product = parseFloat(this.c_cartItems[key].price) * parseInt(this.c_cartItems[key].qty)
                price_product_base = parseFloat(this.c_cartItems[key].price) * parseInt(this.c_cartItems[key].qty)

                // Bon cadeau
                if (this.c_payments)
                    if (this.c_payments.filter((m) => m.name == 'Bon cadeau').length > 0) {
                        this.c_payments[this.c_payments.findIndex((m) => m.name == 'Bon cadeau')].value = this.voucherAmount
                    }
                // else {
                //     this.c_payments.push({ name: 'Bon cadeau', value: this.voucherAmount })
                // }

                if (price > 0) {
                    remain = parseFloat(remain) + parseFloat(price)
                } else {
                    remain += price_product
                }
            }

            // Code promo (Global)
            this.c_remainBeforeGlobalPromoCode = remain
            this.c_remainAfterGlobalPromoCode = remain

            if (this.c_order != null) {
                remain -= this.c_order.current_price
                remain -= this.c_order.fidelity_points
                remainPlain = remain
            }

            if (this.c_payments) {
                remain =
                    remain -
                    this.c_payments.reduce((total, current) => parseFloat(total, 10) + parseFloat(current.value || 0, 10), 0)
                remainPlain = remain
            }

            if (this.usedFidelityPoints > 0) {
                remain -= this.usedFidelityPoints / (this.establishment?.fidelity_points_trans || 10)
                remainPlain = remain
            }
            if (remainPlain && this.c_customDiscount && parseFloat(this.c_customDiscount))
                remainPlain -= parseFloat(this.c_customDiscount)

            if (parseFloat(remainPlain) < 0.009) {
                this.c_remainPrice = parseFloat(remainPlain).toFixed(1)

                return parseFloat(remainPlain).toFixed(1)
            } else {
                this.c_remainPrice = parseFloat(remainPlain).toFixed(2)

                return parseFloat(remainPlain).toFixed(2)
            }
        },
    },
    watch: {
        serieSelected: {
            deep: true,
            handler: function (val) {
                this.serieSelected = val
            },
        },
        remainPrice() {
            //
        },
    },
}
</script>
